import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { MotionConfig, AnimatePresence, motion } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import SmoothScroll from "@/components/SmoothScroll";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import { CartProvider } from "@/context/CartContext";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Product from "@/pages/Product";
import Story from "@/pages/Story";
import FAQ from "@/pages/FAQ";
import Contact from "@/pages/Contact";

// Gentle cross-page fade so navigating feels as smooth as the hero.
function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={location.pathname}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
        transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
      >
        <Routes location={location}>
          <Route path="/" element={<Home />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/products/:slug" element={<Product />} />
          <Route path="/our-story" element={<Story />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/contact" element={<Contact />} />
        </Routes>
      </motion.div>
    </AnimatePresence>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <CartProvider>
          <MotionConfig reducedMotion="user">
          <SmoothScroll>
            <div className="grain-overlay" aria-hidden />
            <Navbar />
            <CartDrawer />
            <main>
              <AnimatedRoutes />
            </main>
            <Footer />
            <Toaster position="bottom-right" />
          </SmoothScroll>
          </MotionConfig>
        </CartProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
